var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.69579 7.71654C7.82328 7.71654 9.55406 5.98576 9.5541 3.85827C9.5541 1.73078 7.82324 0 5.69579 0C3.56835 0 1.83752 1.73078 1.83752 3.85827C1.83752 5.98576 3.56831 7.71654 5.69579 7.71654Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5711 7.71654C16.6986 7.71654 18.4294 5.98576 18.4293 3.85827C18.4293 1.73078 16.6986 0 14.5711 0C12.4436 0 10.7128 1.73078 10.7128 3.85827C10.7128 5.98576 12.4436 7.71654 14.5711 7.71654Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69577 8.39209C2.5551 8.39209 0 10.947 0 14.0874V16.019C0 16.4139 0.320071 16.7339 0.714875 16.7339H10.6762C11.071 16.7339 11.3911 16.4139 11.3911 16.019V14.0874C11.3911 10.9795 8.88666 8.39209 5.69577 8.39209Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.974 9.66641C10.8739 9.74843 10.8599 9.896 10.9397 9.99784C12.57 12.0773 12.3441 14.0879 12.3441 16.0187C12.3441 16.1631 12.3256 16.3034 12.2908 16.4371C12.2518 16.5874 12.3663 16.7336 12.5215 16.7336H19.5517C19.9465 16.7336 20.2665 16.4135 20.2665 16.0187V14.0871C20.2665 9.24477 14.617 6.68112 10.974 9.66641Z",
    fill: "#565656"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightPeople);
export default __webpack_public_path__ + "static/media/light-people.6fb7fc67.svg";
export { ForwardRef as ReactComponent };